module.exports = __webpack_public_path__ + "img/star_00.95e36ffc.png";